var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Footer"},[_vm._v("@hebic.cn 招生办公室 0311-85334781")])}
var staticRenderFns = []

export { render, staticRenderFns }